import { getJSON } from 'common/services/api'
import dayjs from 'dayjs'
import { useQuery } from 'react-query'
import { getQueryParams } from 'utils/getQueryParams'
import type { IncidentActionsFilterValues } from '../ActionsFilters'

interface UseIncidentActionsParams {
  filterParams?: IncidentActionsFilterValues
  enabled?: boolean
}

export const useIncidentActions = ({
  filterParams,
  enabled = true
}: UseIncidentActionsParams = {}) => {
  const queryParams = getQueryParams({
    fromDate:
      filterParams?.rangePicker?.[0]?.toISOString() ||
      dayjs().subtract(4, 'weeks').startOf('day').toISOString(),
    toDate:
      filterParams?.rangePicker?.[1]?.toISOString() ||
      dayjs().endOf('day').toISOString(),
    ...(filterParams?.statuses?.length && { statuses: filterParams.statuses }),
    ...(filterParams?.ownedBy?.length && {
      assignedUserIds: filterParams.ownedBy
    }),
    ...(filterParams?.categoryItems?.length && {
      categoryItemIds: filterParams.categoryItems
    }),
    ...(filterParams?.currentPage && { page: filterParams.currentPage }),
    ...(filterParams?.itemsPerPage && { limit: filterParams.itemsPerPage })
  })

  const GET_INCIDENT_ACTIONS = `/api/list/incident-report/incident-actions`

  const { data, isLoading, error, refetch } = useQuery(
    ['incident-actions', filterParams],
    () =>
      getJSON({
        url: `${GET_INCIDENT_ACTIONS}?${queryParams}`
      }),
    {
      enabled
    }
  )

  return {
    data: data || [],
    isLoading,
    error,
    refetch
  }
}
